import { Link } from "@components/Link/Link";
import React from "react";
import tw from "twin.macro";

import HeroButton from "./HeroButton";
import { Image } from "../../Image/Image";

const Wrapper = tw.div`
  w-1/2 font-display
`;

const ImageWrapper = tw.div`
  aspect-4-5 sm:aspect-square relative
`;

const InnerImageWrapper = tw.div`
  absolute inset-0
`;

const ButtonWrapper = tw.div`
  flex items-end md:items-center justify-center w-full h-full absolute inset-0 pointer-events-none
`;

const HeroImage = ({ image, onClickImage, imageLink, link, handleClick }) => {
  return (
    <Wrapper>
      <ImageWrapper>
        <InnerImageWrapper>
          {link &&
            link?.url &&
            link?.url !== "" &&
            link?.title &&
            link?.title !== "" && (
              <ButtonWrapper>
                <HeroButton link={link.url} handleClick={handleClick}>
                  {link.title}
                </HeroButton>
              </ButtonWrapper>
            )}
          <Image
            image={image}
            alt={image.alt}
            onClick={onClickImage}
            imageLink={imageLink}
            fullHeight
            critical={true}
            staticImage={true}
          />
        </InnerImageWrapper>
      </ImageWrapper>
      {link &&
        link?.url &&
        link?.url !== "" &&
        link?.title &&
        link?.title !== "" && (
          <HeroButton as={Link} link={link?.url} mobile>
            {link?.title}
          </HeroButton>
        )}
    </Wrapper>
  );
};

export default HeroImage;
